import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { NewDataSourceDefinitionsService } from '../../../../features/data-source/data-source-definitions/services/new-data-source-definitions.service';
import { IDataSourceDefinition } from '../../../interfaces/data-source/data-source-definitions/data-source-definition.interface';

@Component({
  standalone: false,
  selector: 'app-data-source-selector',
  templateUrl: './data-source-selector.component.html',
  styleUrls: ['./data-source-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DataSourceSelectorComponent,
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: DataSourceSelectorComponent,
      multi: true,
    },
  ],
})
export class DataSourceSelectorComponent implements OnInit, ControlValueAccessor, Validators {
  @Input() label: string;
  @Input() hint?: string;

  @Output() onDataSourceChange: EventEmitter<IDataSourceDefinition> =
    new EventEmitter<IDataSourceDefinition>();

  definitions: IDataSourceDefinition[] = [];
  isDisabled: boolean = false;

  control!: AbstractControl;

  private _value: string = '';

  set value(val: string) {
    if (val !== undefined && this._value !== val) {
      this._value = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  get value(): string {
    return this._value;
  }

  constructor(private readonly newDataSourceDefinitionsService: NewDataSourceDefinitionsService) {}

  ngOnInit() {
    this.initDefinitions();
  }

  onChange: any = () => {};

  onTouch: any = () => {};

  writeValue(value: string) {
    this.value = value;
  }

  validate(control: AbstractControl) {
    this.control = control;
  }

  registerOnChange(fn: Function) {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }

  changeDataSource(dataSource: IDataSourceDefinition) {
    this.onDataSourceChange.emit(dataSource);
  }

  onBlur() {
    this.onTouch();
  }

  private async initDefinitions() {
    this.definitions = await this.newDataSourceDefinitionsService.getAll();

    if (!this.checkIfRequired(this.control)) {
      this.definitions.unshift({
        alias: '',
        name: 'None',
      } as IDataSourceDefinition);
    }

    // If we update the form's value before we have our definitions
    const alreadyExistedDefinition = this.definitions.find(
      (definition) => definition.alias === this.value,
    );
    if (alreadyExistedDefinition) {
      this.changeDataSource(alreadyExistedDefinition);
    }
  }

  private checkIfRequired(control: AbstractControl): boolean {
    return control?.hasValidator(Validators.required);
  }
}
